export { BULLRUN_BREAKPOINTS, BULLRUN_COLORS, MOBILE_LAYOUT } from "@orb-labs/orby-react/bullrun";

export const theme = {
  colors: {
    /** Shell / ticker backdrop (matches `index.html` root background). */
    bg: "#110e0a",
    bgCard: "#0a0a10",
    bgCardHover: "#0e0e18",
    border: "#141420",
    text: "#eeeef2",
    textMid: "#a0a0b8",
    textDim: "#55556a",
    accent: "#00e87b",
    accentDim: "rgba(0, 232, 123, 0.1)",
    red: "#ff4d6a",
    blue: "#4d8eff",
    purple: "#a855f7",
    yellow: "#ffc94d",
    goldDim: "rgba(255, 201, 77, 0.15)",
    blueDim: "rgba(77, 142, 255, 0.12)",
    purpleDim: "rgba(168, 85, 247, 0.12)",
  },
  layout: {
    maxWidth: "1080px",
    shellMaxWidth: "2200px",
    navHeight: "56px",
    tickerHeight: "40px",
    sectionPadding: "48px",
    sectionPaddingMobile: "24px",
  },
  radii: {
    sm: "6px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    full: "100px",
  },
} as const;

export type Theme = typeof theme;

export const LAYOUT = {
  topBarHeight: 59,
  topBarInsetY: 8,
  bottomBarHeight: 40,
  rowHeight: 94,
  tableHeaderHeight: 45,
  contentGap: 8,
  pageHorizontalPadding: 0,
  sideColumnWidth: 360,
} as const;
